/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  getOrientation,
  resetOrientation,
  checkImage,
  getPermissionStatus,
  convertDateInTimezone,
  fetchApi
} from "../../../utils/methods";
import { saveChallengeData, createActivityChallengeV2, getChallengeDetails } from "../../../redux/actions/challengeActions";
import {
  getUserCompanyDetails,
  allowChallengeEventForSpouseDependent,
} from "../../../redux/actions/userProfileActions";
import { TimeZone, imageErrorMessage } from "../../../utils/constants";
import { withTranslation } from "react-i18next";
import {
  Layout,
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
  EditorContainer,
  Border,
  StyledInputSearch
} from "../../CreateEvent/style";
import StepsHeading from "../../RecogntionAdmin/corevalues/stepNames"; 
// import RadioButton from "../../CustomRadioButton";
import { Main } from "../../AdminTeamCreation/styles";
import { closeIcon, SearchButtonIcon, UploadIcon, RecognitionCloseIcon, AdminRightArrowIcon, AdminLeftArrowIcon, RecognitionTickIcon, CalendarBranding } from '../../../utils/icons';
import {CustomInput, SurvivorAverage, SurvivorChallengeSection, TitleContainer,/* CustomTextArea*/} from '../ActivityChallengeCreation/styles';
import {
  Heading, Locationwrapper
} from "../../CreateEvent/style";
import { getCompanyLocation, editLiveChallenge, getCompanyDepartment } from "../../../redux/actions";
import { GetTeams, GetCompanyTeamUsers, GetCompanyInfo, EditChallengeAPI } from '../../../redux/constants/apiConstants';
import { http } from '../../../redux/http';
import { ImageUrl } from "../../../utils/constants";
import { DateCalendarWrapper } from '../../ChallengeDetailsV2/StartChallengePopUp/styles';
import { challengeTierPoints } from "../../../../mockData";
import CommonImageUploader from "../../common/CommonImageUploader/CommonImageUploader";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
import { SearchFilter1 } from "../../PeopleHomeV2/styles";
import { t } from "i18next";
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { FormHeading } from "../ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../../Manager/styles";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {CommonButtonPopup} from '../../ReportsV2/styles'
import {CommonButtonBorder} from '../../common/commonStyles'
import {RadioButtonWrapper, RadioButton, RadioButtonDisabled} from '../../RecogntionAdmin/styles'
import {DateCard} from '../ActivityChallengeLaunch/style'
import DatePopupCalendar from '../../common/DateRangePicker/daCalendarPopup'
// import parse from 'react-html-parser';


dayjs.extend(utc)
dayjs.extend(timezone)

class EditChallenge extends Component {

  constructor(props) {
    super();
    const { survivorChallengeData, isGroupChallenge, isSurvivorChallenge, createLibrary} = props;
    let ImageName = '';
    if (!_.isEmpty(survivorChallengeData) && (props.activityChallengeById || props.editLibrary)) {
      const Array = survivorChallengeData.image.split('/');
      ImageName = Array[Array.length - 1];
    }
    let updatedTiers = challengeTierPoints;
    const challengeTimezone = survivorChallengeData && survivorChallengeData.time_zone;
    this.state = {
      title: _.get(survivorChallengeData, 'title', ''),
      // date: _.get(survivorChallengeData, 'start_date', moment().format('MM/DD/YYYY')),
      date:  survivorChallengeData && survivorChallengeData.start_date? dayjs.utc(survivorChallengeData.start_date).tz(challengeTimezone).format("MM/DD/YYYY"):null,
      // endDate: _.get(survivorChallengeData, 'end_date', moment().format('MM/DD/YYYY')),
      endDate:  survivorChallengeData && survivorChallengeData.end_date? dayjs.utc(survivorChallengeData.end_date).tz(challengeTimezone).format("MM/DD/YYYY"):null,
      apiChecker: (convertDateInTimezone(survivorChallengeData.start_date)._d < dayjs().$d && convertDateInTimezone(survivorChallengeData.end_date)._d >= dayjs().$d) ? true : false,
      description: _.get(survivorChallengeData, 'body', ''),
      imageName: ImageName,
      time: _.get(survivorChallengeData, 'time', dayjs().format('hh:mm a')),
      endTime: _.get(survivorChallengeData, 'endTime', dayjs().format('hh:mm a')),
      showDateTimeInput: '',
      activityType: isGroupChallenge ? survivorChallengeData.event_type === 'Total Steps' ? 'Total Group Steps' : survivorChallengeData.event_type === 'Total Calories' ? 'Total Group Calories' : 'Total Group Distance' : _.get(survivorChallengeData, 'event_type', 'Total Distance'),
      challengePointValue: _.get(survivorChallengeData, 'challenge_point', '10'),
      challengeMode: createLibrary ? 'Solo' : _.get(survivorChallengeData, 'challenge_mode', ''),
      weeklyIncrement: _.get(survivorChallengeData, 'weekly_increment', 0),
      survivorAverage: _.get(survivorChallengeData, 'survivor_average', 0),
      amigosToInvite: [],
      openDateTimePicker: '',
      imgSrc: ImageUrl+"/"+_.get(survivorChallengeData, 'image', ''),
      editImage:_.get(survivorChallengeData, 'image', ''),
      companies: survivorChallengeData.challenge_companies? survivorChallengeData?.challenge_companies?.split(",")?.map((value) => parseInt(value,10)):[],
      selected_companies: survivorChallengeData.challenge_companies? survivorChallengeData?.challenge_companies?.split(",")?.map((value) => parseInt(value,10)):[],
      city_location:survivorChallengeData&& survivorChallengeData.challenge_city_states?survivorChallengeData&& survivorChallengeData.challenge_city_states&& survivorChallengeData.challenge_city_states?.split(",")?.map((value) => parseInt(value,10)):[],
      selectTed_city_location:survivorChallengeData&& survivorChallengeData.challenge_city_states?survivorChallengeData&& survivorChallengeData.challenge_city_states&& survivorChallengeData?.challenge_city_states?.split(",")?.map((value) => parseInt(value,10)):[],
      location: [],
      usersToInvite:survivorChallengeData&& survivorChallengeData.is_team_challenge?3:survivorChallengeData?.challenge_city_states?2: survivorChallengeData?.challenge_departments?1: 0,
      isSpouse: survivorChallengeData.challenge_for_spouse,
      isDependent: survivorChallengeData.challenge_for_dependent,
      isEmployee: false,
      challengePoints: updatedTiers,
      activityChallengeType: createLibrary ? "Classic challenge" : survivorChallengeData.challenge_type === 'new_group' ? 'Group Challenge' : survivorChallengeData.challenge_type === 'group' ? 'Classic challenge' : 'Survivor challenge',
      survivorChallenge: isSurvivorChallenge,
      groupChallenge: isGroupChallenge,
      imageUpdated: 0,
      challengePointKey: _.get(survivorChallengeData, 'challenge_point', '0')+" "+"Points",
      emailOption: {
        "launch_challenge_email": 0,
        "challenge_reminder_email": 0,
        "challenge_complete_email": 0
      },
      companiesPermission: false,
      locationPermission: false,
      selectedOption: 1,
      surveyId: '',
      searchTerm: '',
      filteredCompanies:[],
      surveyType: '',
      dailyGoal: _.get(survivorChallengeData, 'daily_goal', 0) || 0,
      selectedDailyGoalOption: survivorChallengeData&& survivorChallengeData.daily_goal?0:1,
      is_team_challenge:0,
      teams:survivorChallengeData&& survivorChallengeData.team?survivorChallengeData&& survivorChallengeData.team:[],
      selected_teams:survivorChallengeData&& survivorChallengeData.team?survivorChallengeData&& survivorChallengeData.team:[],
      allTeams:[],
      selectedCompany:{
        "id": 1,
        "company_name": "Woliba",
        "show_biometric": 1,
        "spouse_or_dependent": 1,
        "company_start_date": 2016,
        "show_events": 1,
        "show_education": 1,
        "show_employee_directory": 1 },

      step: 1,
      activityArrow: false,
      challengeType: false,
      pointsArrow: false,
      buttonClickScrollTop: false,
      menuIsOpen: true,
      selectedCompanyCheckBox: 0,
      selectedCompanyValue:null,
      selectedCompanyName: null,
      // showLocation: survivorChallengeData&& survivorChallengeData?.is_team_challenge?1:survivorChallengeData?.challenge_city_states?0:5,
      scheduleChallenge: 0,
      buttonStatus: false,
      launchStartDateActive: false,
      launchEndDate:(dayjs.utc(survivorChallengeData.end_date).tz(challengeTimezone)),
      launchEndDateActive: false,
      launchStartDate: (dayjs.utc(survivorChallengeData.start_date).tz(challengeTimezone)),
      weekArrow: false,
      challengeLength: survivorChallengeData && survivorChallengeData.weeks+1,
      city_department: survivorChallengeData && survivorChallengeData.challenge_departments ? survivorChallengeData && survivorChallengeData.challenge_departments && survivorChallengeData?.challenge_departments?.map((value) => parseInt(value, 10)): [],
      selected_city_department: survivorChallengeData && survivorChallengeData.challenge_departments ? survivorChallengeData && survivorChallengeData.challenge_departments && survivorChallengeData?.challenge_departments?.map((value)=> parseInt(value, 10)): [],
      companyInfo:null,
      selected_city_location:survivorChallengeData&& survivorChallengeData.challenge_city_states?survivorChallengeData&& survivorChallengeData.challenge_city_states&& survivorChallengeData?.challenge_city_states?.split(",")?.map((value) => parseInt(value,10)):[],
      survivorEndDateValue: survivorChallengeData && survivorChallengeData.end_date? dayjs.utc(survivorChallengeData.end_date).tz(challengeTimezone).format("MM/DD/YYYY"):null,
      lastDayToJoin: survivorChallengeData?.days_until_last_date,
      lastDayCustom: survivorChallengeData?.days_until_last_date===3||survivorChallengeData?.days_until_last_date===7||survivorChallengeData?.days_until_last_date===14?null:survivorChallengeData?.days_until_last_date? "Custom":null,
      showDatePopupModal: false,
      datePopup:"date",
      charCount:0
    };
    this.onSelectPoints = this.onSelectPoints.bind(this);
  }

  componentDidMount() {
    // this.getTeams(this.props.companyDetails.id);
    const { survivorChallengeData} = this.props;
    this.props.activityChallengeById || this.props.editLibrary ? this.fillProps() : null;
    const companiesPermission = getPermissionStatus("Show companies in challenge", this.props.userPermissions);
    const locationPermission = getPermissionStatus("Show locations in challenge", this.props.userPermissions);
    // this.props.getSurveyLibraries();
    // if (companiesPermission) {
  
    // } else {
    this.props.fetchCompanyForUser();
    this.props.allowChallengeEventForSpouseDependent();
    // this.setState({
    //   companies: this.props.userCompany && [this.props.userCompany.id]
    // })
    // }
    this.setState({
      companiesPermission: companiesPermission,
      locationPermission: locationPermission
    })
    document.addEventListener('mousedown', this.handleClick);
    if(!survivorChallengeData?.is_global_challenge){
      this.getCompanyInfo(survivorChallengeData?.challenge_companies);
      this.getTeams(survivorChallengeData?.challenge_companies)
    }
    // if(this.props.role != "ADMIN"){
    //   this.getTeams(this.props.companyDetails.id);
    // }else{
    //   this.onCompanySelect('selectedCompany', this.state.selectedCompany, this.state.selectedCompany['key'])
    // }
    this.setState({filteredCompanies:this.props.allCompanies})
  }

  
  getCompanyInfo = async(companyId)=>{
    let apiUrl = GetCompanyInfo + "/" + companyId;
    try {
      const res = await fetchApi(apiUrl , "GET");
      if (res.status === "success") {
        this.setState({companyInfo: res?.data?.companyInfo?.[0]})

      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }

  }

  onSelectCompanyAndTeam = (value) => {
    this.props.getCompanyLocation(value);
    this.getTeams(value);
  };

  componentDidUpdate(prevProps) {
    if (this.props.survivorChallengeData !== prevProps.survivorChallengeData || prevProps.surveyLibraries !== this.props.surveyLibraries) {
      this.props.activityChallengeById || this.props.editLibrary ? this.fillProps() : null;
    }
    const { survivorChallengeData, allCompanies } = this.props;

    if (allCompanies && this.state.selectedCompanyValue?.length === 0) {
      allCompanies &&
        allCompanies.map((company) => {
          if (company.id == survivorChallengeData.challenge_companies) {
            this.setState({
              selectedCompanyValue: company.company_name,
            });
          }
        });
    }

  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  showCalendar = (date) =>{
    if(date=="launchEndDateActive"){
      this.setState({
        launchEndDateActive: true,
        launchStartDateActive: false
      })}

    else{
      this.setState({
        launchStartDateActive: true,
        launchEndDateActive: false
      })
    }
  }

  onChangeDate = (value) => {
    let dateStr = value;
    let parts = dateStr.split('-');
    let formattedDate = parts[2] + '-' + parts[0] + '-' + parts[1];
    this.setState({
      endDate: new Date(convertDateInTimezone(formattedDate)),
      placeholder:new Date(convertDateInTimezone(formattedDate)),
      buttonStatus:false
    })
  }

  onChangeDateV1 = (date, stateName) => {
    this.setState({
      [stateName]: dayjs(date),
    }, () => this.setEndDateSurvivor(date));
  };

  setEndDateSurvivor = (date) =>{
    const { challengeLength } = this.state;
    this.setState({
      survivorEndDateValue : dayjs(date)
        .add((challengeLength * 7) - 1, 'day')
        .format('MM/DD/YYYY')
    })
  }

  hideCalendar = () =>{
    this.setState({
      launchEndDateActive: false
    })
  }

  onChanegeButton = (value) => {
    this.setState({
      launchEndDate:dayjs(value),
      endDate: dayjs(value)
    })
  }

  onCompanySelect = async(name, value, key = '') => {
    const { challengePointKey } = this.state;
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${GetCompanyTeamUsers}/${value.id}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          allTeams:res,
          [name]: value,
          challengePointKey: key != '' ? key : challengePointKey,
          // companies:[value.id]
        })
      }
    }catch(error){
      toast.error(error.message);
    }
    
  };

  fillProps = () => {
    const { survivorChallengeData, isGroupChallenge, isSurvivorChallenge, surveyLibraries, allCompanies } = this.props;
    const Array = survivorChallengeData.image.split('/');
    let ImageName = Array[Array.length - 1];
    let tierPointsIndex = this.state.challengePoints.findIndex((data) => data.value == _.get(survivorChallengeData, 'challenge_point', '0'));
    let surveyIndex = surveyLibraries && surveyLibraries.length > 0 ? surveyLibraries.findIndex((data) => data.id === survivorChallengeData.survey_id) : -1;
    // if(survivorChallengeData.is_global_challenge===0){
    //   this.onSelectCompanyAndTeam(survivorChallengeData&&survivorChallengeData.challenge_companies);
    // }
    const challengeTimezone = survivorChallengeData && survivorChallengeData.time_zone;
    const plainText = _.get(survivorChallengeData, 'body')
      ?.replace(/<[^>]*>/g, '')
      ?.replace(/&nbsp;/g, ' ')
      ?.trim();
    this.setState({
      title: _.get(survivorChallengeData, 'title'),
      // date: survivorChallengeData && survivorChallengeData.start_date?survivorChallengeData && moment(survivorChallengeData.start_date).format('MM/DD/YYYY'):"" ,
      // date:  survivorChallengeData && survivorChallengeData.start_date? dayjs(survivorChallengeData.start_date).format("MM/DD/YYYY"):null,
      date:  survivorChallengeData && survivorChallengeData.start_date? dayjs.utc(survivorChallengeData.start_date).tz(challengeTimezone).format("MM/DD/YYYY"):null,
      // endDate: survivorChallengeData && survivorChallengeData.start_date?survivorChallengeData && moment(survivorChallengeData.end_date).format('MM/DD/YYYY'):"" ,
      // endDate:  survivorChallengeData && survivorChallengeData.end_date? dayjs(survivorChallengeData.end_date).format("MM/DD/YYYY"):null,
      endDate:  survivorChallengeData && survivorChallengeData.end_date? dayjs.utc(survivorChallengeData.end_date).tz(challengeTimezone).format("MM/DD/YYYY"):null,
      description: _.get(survivorChallengeData, 'body'),
      activityType: isGroupChallenge ? survivorChallengeData.event_type === 'Total Steps' ? 'Total Group Steps' : survivorChallengeData.event_type === 'Total Calories' ? 'Total Group Calories' : 'Total Group Distance' : _.get(survivorChallengeData, 'event_type', 'Total Distance'),
      challengePointValue: tierPointsIndex == -1 ? 0 : _.get(survivorChallengeData, 'challenge_point', '12'),
      challengeMode: _.get(survivorChallengeData, 'challenge_mode') || 'Solo',
      weeklyIncrement: _.get(survivorChallengeData, 'weekly_increment', 0) || 0,
      survivorAverage: _.get(survivorChallengeData, 'survivor_average', 0) || 0,
      imgSrc: ImageUrl+"/"+_.get(survivorChallengeData, 'image', ''),
      editImage:_.get(survivorChallengeData, 'image', ''),
      imageName: ImageName,
      survivorChallenge: isSurvivorChallenge,
      groupChallenge: isGroupChallenge,
      activityChallengeType: survivorChallengeData.challenge_type === 'new_group' ? 'Group Challenge' : survivorChallengeData.challenge_type === 'group' ? 'Classic challenge' : 'Survivor challenge',
      challengePointKey: this.state.challengePointValue+" "+"Points",
      surveyId: survivorChallengeData.survey_id,
      surveyType: surveyLibraries && surveyLibraries.length > 0 ? surveyLibraries[surveyIndex === -1 ? 0 : surveyIndex].survey_name : '',
      selectedOption: surveyIndex === -1 ? 1 : 0,
      dailyGoal: _.get(survivorChallengeData, 'daily_goal', 0) || 0,
      companies: survivorChallengeData.challenge_companies? survivorChallengeData?.challenge_companies?.split(",")?.map((value) => parseInt(value,10)):[],
      selectedCompany: survivorChallengeData?.challenge_companies?.split(",")?.map((value) => parseInt(value,10)),
      selected_companies: survivorChallengeData.challenge_companies? survivorChallengeData?.challenge_companies?.split(",")?.map((value) => parseInt(value,10)):[],
      selectedCompanyCheckBox: this.state.companies && this.state.companies.length>1?0:1,
      city_location:survivorChallengeData&& survivorChallengeData.challenge_city_states?survivorChallengeData&& survivorChallengeData.challenge_city_states&& survivorChallengeData?.challenge_city_states?.split(",")?.map((value) => parseInt(value,10)):[],
      selected_city_location:survivorChallengeData&& survivorChallengeData.challenge_city_states?survivorChallengeData&& survivorChallengeData.challenge_city_states&& survivorChallengeData?.challenge_city_states?.split(",")?.map((value) => parseInt(value,10)):[],
      // showLocation: survivorChallengeData&& survivorChallengeData.is_team_challenge?1:survivorChallengeData?.challenge_city_states?0: survivorChallengeData?.challenge_departments?6: 5,
      usersToInvite:survivorChallengeData&& survivorChallengeData.is_team_challenge?3:survivorChallengeData?.challenge_city_states?2: survivorChallengeData?.challenge_departments?1: 0,
      teams:survivorChallengeData&& survivorChallengeData.team?survivorChallengeData&& survivorChallengeData.team:[],
      selected_teams:survivorChallengeData&& survivorChallengeData?.team?survivorChallengeData&& survivorChallengeData?.team:[],
      selectedDailyGoalOption: this.state.dailyGoal ? 0 : 1,
      challengeLength: survivorChallengeData && survivorChallengeData?.weeks+1,
      city_department: survivorChallengeData?.challenge_departments?.map(Number),
      selected_city_department: survivorChallengeData?.challenge_departments?.map(Number),
      spouse:_.get(survivorChallengeData, 'challenge_for_spouse'),
      dependent:_.get(survivorChallengeData, 'challenge_for_dependent'),
      survivorEndDateValue: survivorChallengeData && survivorChallengeData.end_date? dayjs.utc(survivorChallengeData.end_date).tz(challengeTimezone).format("MM/DD/YYYY"):null,
      charCount: plainText?.length
      // emailOption: {
      //   "launch_challenge_email": survivorChallengeData?.launch_challenge_email,
      //   "challenge_reminder_email": survivorChallengeData?.challenge_reminder_email,
      //   "challenge_complete_email": survivorChallengeData?.challenge_complete_email
      // },
    },()=>{
      if(survivorChallengeData?.is_global_challenge===0){
        this.getTeams(survivorChallengeData?.challenge_companies);
        this.props.getCompanyLocation(survivorChallengeData?.challenge_companies);
        this.props.getCompanyDepartment(survivorChallengeData?.challenge_companies);
      }

      if (allCompanies) {
        allCompanies &&
          allCompanies.map((company) => {
            if (company.id == survivorChallengeData.challenge_companies) {
              this.setState({
                selectedCompanyValue: company.company_name,
              });
            }
          });
      }

      
    })
  }

  activityChallengeTypes = [
    {"key": "Classic challenge", "value": 'Classic challenge'},
    {"key": "Survivor challenge", "value": 'Survivor challenge'},
    {"key": "Group Challenge", "value": 'Group Challenge'}
  ]

  activityTypesItems= [
    {"key": "Total Steps", "value": 'Total Steps', 'label':"Steps"},
    {"key": "Total Distance", "value": 'Total Distance', 'label':"Distance"},
    {"key": "Total Calories", "value": 'Total Calories', 'label':"Calories"}
  ]

  groupActivityTypesItems= [
    {"key": "Total Group Steps", "value": 'Total Group Steps', 'label':"Total group steps"},
    {"key": "Total Group Distance", "value": 'Total Group Distance', 'label':"Total group distance"},
    {"key": "Total Group Calories", "value": 'Total Group Calories', 'label':"Total group Calories"}
  ]

  renderHeading = () => {
    const { survivorChallengeData } = this.props;
    const challengeType= survivorChallengeData.challenge_type=="survivor"?"Survivor Challenge":survivorChallengeData.challenge_type=="group"&&survivorChallengeData.is_team_challenge?this.props.t("Team Challenge"):survivorChallengeData.challenge_type=="new_group"?this.props.t("Charity Challenge"):this.props.t("Classic Challenge")
    return(
      <FormHeading color={"#184A61"}>
        <div className="close-icon" onClick={() => window.history.back() }>
          <ManagerIconContainer isWidth={"34px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
        </div>
        {this.props.t("Edit ")} {this.props.t(challengeType)}
      </FormHeading>
    )};

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChange = (e) => {
    let file = e.target.files[0];
    if (checkImage(e.target.files)) {
      if ((file?.size / 1000000) <= 20) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        const array = document.getElementById('create-challenge-file').value.split("\\");
        reader.onloadend = () => {
          this.setState({
            imgSrc: reader.result,
            imageName: array[array.length - 1],
            editImage: reader.result
          });
          getOrientation(file, (or) => {
            resetOrientation([reader.result], or, (baseImage) => {
              this.setState({
                imgSrc: baseImage,
                editImage: baseImage,
                imageUpdated: this.props.editLibrary ? 1 : 0
              });
            });
          });
        };
      } else {
        toast.error('Please select image file less than 20MB');
        document.getElementById('create-challenge-file').value = '';
      }
    } else {
      toast.error(imageErrorMessage);
      document.getElementById('create-challenge-file').value = '';
    }
  };

  removePhoto = () => {
    this.setState({
      imgSrc: '',
      imageName: '',
      editImage: ''
    });
  };


  handleImageChange = (imageSrc, imageName, editImage) => {
    this.setState({
      imgSrc: imageSrc,
      imageName: imageName,
      editImage: editImage,
    });
  };
  
  handleRemoveImage = () => {
    this.setState({ imgSrc: null, editImage: null });
  };
  

  onChangeDescription = (e) => {
    const newContent = e.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
  };

  getTeams = async(companyId)=>{
    const AuthToken = localStorage.getItem('AUTH_TOKEN');
    try {
      const res = await http.get(`${GetTeams}/${companyId}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        this.setState({
          allTeams:res
        })
      }
    }catch(error){
      toast.error(error.message);
    }
  }

  stepOneForm = () => {
    const {
      title,
      description,
      step,
      charCount
    } = this.state;
    const { t } = this.props;
    const maxLength = 3000;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challenge" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Title of the challenge")}{<span className="imp">*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={t("Write title here...")}
                    name="title"
                    onChange={this.onChangeInput}
                    value={title}
                    maxLength="100"
                    pColor={"#BDBDBD"}
                    color="#184A61"
                    isBorderColor={"1px solid #BDBDBD"}
                  />
                </InputContainer>
                <Border style={{ background: '#EFEFEF', margin: '8px 0 8px 0px' }} />
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("Challenge image")}{<span className="imp">*</span>}<span className="subtext">{("(use illustration)")}</span></StyledLabel>
                <CommonImageUploader
                  imgSrc={this.state.imgSrc}
                  t={t}
                  closeIcon={closeIcon}
                  UploadIcon={UploadIcon}
                  onImageChange={this.handleImageChange}
                  onRemoveImage={this.handleRemoveImage}
                />    
                <Border style={{ background: '#EFEFEF', margin: '8px 0px' }} />               
                <InputContainer>
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">{this.props.t("About the challenge")}{<span className="imp">*</span>}</StyledLabel>
                  <EditorContainer>
                    <CKEditor
                      editor={ClassicEditor}
                      data={description}
                      config={{
                        placeholder: 'Write description here...',
                        contentStyle: 'body { color: #184A61 !important; }'
                      }}
                      onReady={(editor) => {
                        this.editorInstance = editor;

                        const modelDocument = editor.model.document;

                        modelDocument.on('change:data', () => {
                          const data = editor.getData();
                          const plainText = data
                            .replace(/<[^>]*>/g, '')
                            .replace(/&nbsp;/g, ' ')
                            .trim();

                          const count = plainText?.length;

                          if (count > maxLength) {
                            editor.execute('undo');
                            return;
                          }

                          this.setState({
                            description: data,
                            charCount: count,
                            disableButton: false,
                          });
                        });
                      }}
                    />

                  </EditorContainer>
                  <div className="char-count">{charCount||0}/3000 | C</div>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  onSelect = (name, value, key) => {
    // const { challengePointKey } = this.state;
    (name === "activityChallengeType") ?
      this.setState({
        [name]: value,
        survivorChallenge: value === "Survivor challenge",
        groupChallenge: value === "Group Challenge",
        activityType: value === "Group Challenge" ? "Total Group Distance" : "Total Distance",
        challengePointKey: this.state.challengePointKey,
        activityChallengeValue: key
      }) :
      this.setState({
        [name]: value,
        // challengePointKey: key != '' ? key : challengePointKey
      });
  };

  onSelectCompany = (name, value, key ) => {
    this.setState({
      [name]: value,
      selectedCompanyName: key
    });
    this.props.getCompanyLocation(value);
    this.getTeams(value);
    this.props.getCompanyDepartment(value);
    
  };

  isNumberKey = (evt) => {
    let charCode = (evt.which) ? evt.which : event.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) evt.preventDefault();
  };

  toggleRadioGoalButton = (value) => {
    this.setState({ usersToInvite: parseInt(value,10) }, () => { });
  };

  onSelectPoint = (name, value, key ) => {
    this.setState({
      [name]: value,
      challengePointKey: key
    });
  };

  onSelectPoints(name) {
    this.setState({
      selectedChallengePoint: name.value,
      challengePointKey: name.key,
      challengePointValue: name.value,
    });
  }

  handleActivityType = (name) => {
    this.setState({
      activityType: name
    })
  };

  stepTwoForm = () => {
    const {
      step,
      groupChallenge,
      activityType,
      survivorChallenge,
      survivorAverage,
      weeklyIncrement,
      challengePointKey,
      challengePointValue,
      selectedDailyGoalOption,
      dailyGoal,
      challengePoints,
      pointsArrow
    } = this.state;
    const { t, survivorChallengeData } = this.props;
    let currentDate = dayjs();
    const startChallengeEditButton= dayjs(convertDateInTimezone(survivorChallengeData.start_date)._d).format('MM-DD-YYYY')<=dayjs(currentDate).format('MM-DD-YYYY')&&survivorChallengeData.is_user_challenge!==1&&survivorChallengeData.challenge_status!="over"&&!survivorChallengeData.is_global_challenge?true:false;
    const activityTypes = groupChallenge ? this.groupActivityTypesItems : this.activityTypesItems;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challenge" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                <TitleContainer widthValue="70%" height="auto" padding="0px">
                  <StyledLabel isFont={"14px"} color={"#184A61"} marginb="0px" margin="0px">{this.props.t("Type of activity")}{<span className="imp">*</span>}</StyledLabel>
                  <div className="radioButtonDiv">
                    <RadioButtonWrapper isMargin="12px" width gap>
                      {activityTypes?.map((data,index)=>(
                        <div className="RadioButtonContainer " key={index}>
                          <RadioButtonDisabled
                            type="radio"
                            checked={activityType === data.key}
                            handler={this.handleActivityType}
                            id={data.label+1}
                            disabled
                          />
                          <div className="label">{data?.label}</div>              
                        </div>))}
                    </RadioButtonWrapper>
                  </div>
                  <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/>
                </TitleContainer>
                {(groupChallenge) &&
                  <SurvivorAverage isMargin={"0px"} width="100%" marginb="0px" isHeight={"48px"}>
                    <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{activityType.includes('Distance')?"Total group distance goal": activityType.includes('Step')?"Total group step goal":"Total group calories goal"}{<span className="imp">*</span>}</StyledLabel>
                    <CustomInput
                      height={"48px"}
                      isRadius={"4px"}
                      isBorder={"1px solid #BDBDBD"}
                      isBgColor={"#EFEFEF"}
                      disabled
                      type='number'
                      name='survivorAverage'
                      // onChange={this.onChangeInput}
                      value={activityType.includes('Distance') ? parseFloat(survivorAverage) : parseInt(survivorAverage,10)}
                      pattern='[0-9]*'
                      min="0"
                      onKeyPress={(e) => this.isNumberKey(e)}
                      placeholder={activityType.includes("Steps")?this.props.t("Enter E.g. 500 Steps"):activityType.includes("Calories")?this.props.t("Enter E.g. 30 Calories"):this.props.t("Enter E.g. 25 Miles")}
                    />
                    {<Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/> }
                  </SurvivorAverage>}
                <SurvivorChallengeSection>
                  {(survivorChallenge) && <SurvivorAverage display="block" isMargin={"0px"} marginb="0px" isHeight={"48px"} width="49.5%">
                    <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{groupChallenge ? t('Team Goal') : t('Week one Goal')}{<span className="imp">*</span>}</StyledLabel>
                    <CustomInput
                      disabled
                      width="100%"
                      height={"48px"}
                      isRadius={"4px"}
                      isBorder={"1px solid #BDBDBD"}
                      isBgColor={"#EFEFEF"}
                      type='number'
                      name='survivorAverage'
                      // onChange={this.onChangeInput}
                      value={activityType.includes('Distance') ? parseFloat(survivorAverage) : parseInt(survivorAverage,10)}
                      pattern='[0-9]*'
                      min="0"
                      onKeyPress={(e) => this.isNumberKey(e)}
                      placeholder={this.props.t("Enter aim/goal")}
                    />
                  </SurvivorAverage>}
                  {survivorChallenge &&
              <SurvivorAverage display="block" width="49.5%" isMargin={"0px"} marginb="0px" isHeight={"48px"}>
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{t("Weekly increment")}{<span className="imp">*</span>}</StyledLabel>
                <CustomInput
                  disabled
                  width="100%"
                  height={"48px"}
                  isRadius={"4px"}
                  isBorder={"1px solid #BDBDBD"}
                  isBgColor={"#EFEFEF"}
                  type='number'
                  name="weeklyIncrement"
                  value={parseInt(weeklyIncrement)}
                  // onChange={this.onChangeInput}
                  pattern='[0-9]*'
                  min="0"
                  onKeyPress={(e) => this.isNumberKey(e)}
                  placeholder={this.props.t("Enter increment")}
                />
              </SurvivorAverage>}
                  {(survivorChallenge) &&  <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px', display:"flex"}}/>}
                </SurvivorChallengeSection>
                <TitleContainer widthValue="70%" height="275px" padding="0px" margin="0 0 8px 0">
                  <CommonDropdown
                    tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                    dropdownStyle={{ top: "90px" }}
                    labelText={t("Challenge point value")}
                    isRequired={true}
                    dropdownOpen={pointsArrow}
                    placeholder={t("Select point palue")}
                    title={challengePointKey=="0 Points"?"No Points":challengePointKey?t(challengePointKey) : t("Select point value")}
                    id="dropdown-recurring"
                    onClick={() => this.setState({ pointsArrow: !pointsArrow })}
                    data={challengePoints}
                    onSelect={this.onSelectPoints}
                    active={challengePointValue}
                    onSelectParameter={["value", "key"]}
                    itemValue={true}
                    valueIndex={1}
                    labelMargin={"0px"}
                    t={t}
                    fontSize={"14px"}
                    dropIcon={true}
                  />
                  {/* <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px 0px 0px'}}/> */}
                </TitleContainer>
                {survivorChallengeData.challenge_type === 'group'?<Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px', display:"flex"}}/>:null}
                {survivorChallengeData.challenge_type === 'group'?<StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="0px">
                  {this.props.t("Would you like to set a daily goal")} ?{<span className="imp">*</span>}
                </StyledLabel>:null}
                {survivorChallengeData.challenge_type === 'group'?<div className="radioButtonDiv"><RadioButtonWrapper width gap>
                  <div className="RadioButtonContainer " onClick={startChallengeEditButton?null:() => this.toggleRadioButton("selectedDailyGoalOption",0)}>
                    <RadioButtonDisabled
                      type="radio"
                      name="option"
                      checked={selectedDailyGoalOption === 0}
                      handler={startChallengeEditButton?null:this.toggleRadioButton}
                      id="1"
                      value={0}
                    />
                    <div className="label">Yes</div>
                  </div> 
                  <div className="RadioButtonContainer " onClick={startChallengeEditButton?null:() => this.toggleRadioButton("selectedDailyGoalOption",1)}>
                    <RadioButtonDisabled
                      type="radio"
                      name="option"
                      checked={selectedDailyGoalOption === 1}
                      handler={startChallengeEditButton?null:this.toggleRadioButton}
                      id="2"
                      value={1}
                    />
                    <div className="label">No</div>
                  </div>
                </RadioButtonWrapper></div>:null}
                {selectedDailyGoalOption===0 && survivorChallengeData.challenge_type === 'group' &&<Border style={{background:'#EFEFEF',margin:'8px 0px 0px 0px', display:"flex"}}/>}
                {selectedDailyGoalOption===0 &&
                <SurvivorAverage width="100%"  isHeight={"48px"} isMargin="8px">
                  <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px">{t("Individual daily goal")}</StyledLabel>
                  <CustomInput
                    isFont={"lato"}
                    isRadius={"4px"}
                    isBorder={"1px solid #BDBDBD"}
                    isBgColor={"#EFEFEF"}
                    disabled={startChallengeEditButton}
                    type='number'
                    name='dailyGoal'
                    onChange={startChallengeEditButton?null:this.onChangeInput}
                    value={dailyGoal}
                    maxLength="10"
                    placeholder={activityType==="Total Distance"?"Enter distance goal":activityType==="Total Calories"?"Enter calorie goal":"Enter step goal"}
                  />
                </SurvivorAverage>}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    this.setState({ searchTerm: value });

    const filtered = this.props.allCompanies.filter((company) =>
      company.company_name.toLowerCase().includes(value)
    );

    this.setState({ filteredCompanies: filtered });
  };

  toggleRadioButton = (name, value) => {
    this.setState({ [name]: value }, () => { });
  };

  dateRadioButton = (name, value ) => {
    this.setState({ [name]: value });
    if(value===1){
      this.setState({
        date: "",
        endDate:''
      })
    }
    if(value===0){
      this.setState({
        date: dayjs().format('MM/DD/YYYY'),
        endDate: dayjs().format('MM/DD/YYYY')
      })
    }
  };

  onSelectSurveyType = (name, value, id) => {
    this.setState({
      [name]: value,
      surveyId: id
    });
  };

  selectAllCompanies = (e) => {
    e.preventDefault();
    let invitedCompanies = [];
    const { allCompanies } = this.props;
    if (this.state.companies.length === allCompanies.length) {
      invitedCompanies = [];
    } else {
      allCompanies && allCompanies?.map((company) => {
        invitedCompanies.push(company.id);
      });
    }
    this.setState({
      companies: invitedCompanies
    })
  };

  onCheckboxChange = (element) => {
    const { companies } = this.state;
    if (companies.includes(element)) {
      let index = companies.findIndex((item) => item === element);
      if (index > -1) {
        companies.splice(index, 1);
      }
    } else {
      companies.push(element);
    }
    this.setState({
      companies: companies
    })
  };

  selectAllLocation = (e, locationDetails) => {
    e.preventDefault();
    const { city_location,selectTed_city_location } = this.state;
    if (city_location.length == locationDetails.length) {
      this.setState({
        city_location: selectTed_city_location,
      });
    } else {
      let arr = [];
      for (let i = 0; i < locationDetails.length; i++) {
        arr.push(locationDetails[i].id);
      }
      this.setState({
        city_location: arr,
      });
    }
  };

  onChangeLocation = (id) => {
    const { city_location } = this.state;
    const updateLocation = [...city_location]
    if (updateLocation&&updateLocation.includes(id)) {
      let index = updateLocation.findIndex((item) => item === id);
      if (index > -1) {
        updateLocation.splice(index, 1);
      }
    } else {
      updateLocation.push(id);
    }
    this.setState({
      city_location: updateLocation
    });
  };

  onChangeDepartment = (id) => {
    const { city_department } = this.state;
    const updateDepartment = [...city_department]
    if (updateDepartment && updateDepartment.includes(id)) {
      let index = updateDepartment.findIndex((item) => item === id);
      if (index > -1) {
        updateDepartment.splice(index, 1);
      }
    } else {
      updateDepartment.push(id);
    }
    this.setState({
      city_department: updateDepartment,
    });
  };

  removeCommaFromFirstPlace = (str) => {
    if (str.charAt(0) === ",") {
      return str.substring(1);
    }
    return str;
  };

  selectAllTeams = (e) => {
    e.preventDefault();
    let invitedTeams = [];
    const { allTeams ,selected_teams} = this.state;
    if (this.state.teams.length === allTeams.length) {
      invitedTeams = selected_teams;
    } else {
      allTeams?.map((company) => {
        invitedTeams.push(company.id);
      });
    }
    this.setState({
      teams: invitedTeams
    })
  };

  onTeamsCheckboxChange = (element) => {
    const { teams } = this.state;

    const updateTeam = [...teams]
    if (updateTeam.includes(element)) {
      let index = updateTeam.findIndex((item) => item === element);
      if (index > -1) {
        updateTeam.splice(index, 1);
      }
    } else {
      updateTeam.push(element);
    }
    this.setState({
      teams: updateTeam
    })
  };

  selectSpouseDependent = (stateName) => {
    this.setState((prev) => ({
      [stateName]: !prev[stateName],
    }));
  };

  onChangeTeam = (id) => {
    const { teams } = this.state;
    if (teams.includes(id)) {
      let index = teams.findIndex((item) => item === id);
      if (index > -1) {
        teams.splice(index, 1);
      }
    } else {
      teams.push(id);
    }
    this.setState({
      teams: teams,
    });
  };

  inviteToggleButton = (e) => {
    this.setState({
      usersToInvite: e,
    });
    if (e === 0) {
      this.setState({
        // city_location: [],
      });
    }
  };

  selectAllDepartment = (e, departmentDetails) => {
    e.preventDefault();
    const { city_department,selected_city_department } = this.state;
    
    if (city_department?.length == departmentDetails?.length) {
      this.setState({
        city_department: selected_city_department
      });
    } else {
      let arr = [];
      for (let i = 0; i < departmentDetails?.length; i++) {
        arr.push(departmentDetails[i].id);
      }
      this.setState({
        city_department: arr,
      });
    }
  };


  stepThreeForm = () => {
    const {
      step,
      selectedCompanyCheckBox,
      companies,
      selectedCompanyValue,
      allTeams,
      teams,
      selected_companies,
      usersToInvite,
      isDependent,
      selected_teams,
      isSpouse,
      companyInfo,
      filteredCompanies,
      city_department,
      city_location,
      spouse,
      dependent,
      selected_city_location,
      selected_city_department
    } = this.state;
    const {  role, locationDetails,departmentList, isAccountManager} = this.props;

    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challenge" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                {(role === "ADMIN"||isAccountManager)&&<StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">
                  {this.props.t("Host your challenge for?")}{<span className="imp">*</span>}
                </StyledLabel>}
                {role=="ADMIN"||isAccountManager&& (
                  <div className="radioButtonDiv">
                    <RadioButtonWrapper width gap isMargin="0px">
                      <div className="RadioButtonContainer" >
                        <RadioButtonDisabled
                          id="global"
                          // handler={this.companyToggleButton}
                          value={0}
                          checked={selectedCompanyCheckBox === 0}
                          label={t("Global")}
                          challengeCreate={true}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="optionglobal"
                          disabled
                        />
                        <div className="label">Global</div>
                      </div>
                      <div className="RadioButtonContainer" >
                        <RadioButtonDisabled
                          id="For an Individual Company"
                          // handler={this.companyToggleButton}
                          value={1}
                          checked={selectedCompanyCheckBox === 1}
                          label={t("For an Individual Company")}
                          challengeCreate={true}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="For an Individual Company"
                          disabled
                        />
                        <div className="label">For an Individual Company</div>
                      </div>
                    </RadioButtonWrapper>
                  </div>
                )}
                {(role === "ADMIN"||isAccountManager) && (<Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px 0px 0px',display:"flex"}}/>)}
                {selectedCompanyCheckBox === 0 && (role=="ADMIN"||isAccountManager) && (
                  <Heading>
                    <div className="name" style={{color:"#184A61", fontSize:"14px"}}>{this.props.t("Select Company To Invite")}</div>
                    <SearchFilter1 style={{width:"416px",maxWidth:"416px"}}>
                      <StyledInputV2
                        type="text" placeholder={t("Search company")}
                        value={this.state.searchTerm} 
                        onChange={this.handleSearch}
                        style={{border:"none"}}
                        isPadding={" 0px 20px 0px 12px"}
                        color="#184A61"
                        border="none"
                        pColor="#BDBDBD"
                      />
                      <div className="search-icon"> {SearchButtonIcon()}</div>
                    </SearchFilter1>
                  </Heading>
                )}
                {selectedCompanyCheckBox === 0 && (role=="ADMIN"||isAccountManager)  ? (
                  <Locationwrapper  background="white" isFlex={'1 1 50%'} isWidth={'49.33%'} >
                    {filteredCompanies && filteredCompanies.length > 0
                      ? filteredCompanies.map((company, index) => (
                        <div className="checkBoxWidth" key={index}>
                          <span style={{color: "#BDBDBD", gap:"16px"}}>
                            <ManagerIconContainer selected={0} disabled={1} isWidth="20px" isHeight="20px">
                              <div
                                className="archive-action"
                              >
                                {companies.includes(company.id) && selected_companies.includes(company.id) ? RecognitionTickIcon("#BDBDBD"):
                                  companies.includes(company.id)?RecognitionTickIcon():
                                    null}
                              </div>
                            </ManagerIconContainer>
                            {company.company_name}
                          </span>
                        </div>
                      ))
                      : null}
                  </Locationwrapper>
                ) : (
                  (role=="ADMIN"||isAccountManager)  && (
                    <React.Fragment>
                      <Heading>
                        <div className="name" style={{color:"#184A61"}}>{this.props.t(`Select a company to invite`)} <span> &nbsp;{companies ? "(01 Company Selected)" : ""} </span></div>
                        <SearchFilter1 style={{width:"416px",maxWidth:"416px"}}>
                          <StyledInputSearch
                            type="text" placeholder={t("Search company")}
                            value={this.state.searchTerm} 
                            onChange={this.handleSearch} 
                            // onKeyDown={this.handleKeyDown}
                            style={{border:"none"}}
                            isPadding={" 0px 20px 0px 12px"}
                          />
                          <div className="search-icon"> {SearchButtonIcon()}</div>
                        </SearchFilter1>
                      </Heading>
   
                      <Locationwrapper background="white" isFlex={'1 1 50%'}>
                        {filteredCompanies && filteredCompanies.length > 0
                          ? filteredCompanies.map((company, index) => (
                            <div className="checkBoxWidth" key={index}>
                              <span style={{color: "#BDBDBD", gap:"16px"}} 
                              >
                                <ManagerIconContainer selected={0} disabled={1} isWidth="20px" isHeight="20px">
                                  <div
                                    className="archive-action"
                                  >
                                    {companies.includes(company.id) && selected_companies.includes(company.id) ? RecognitionTickIcon("#BDBDBD"):
                                      companies.includes(company.id)?RecognitionTickIcon():
                                        null}
                                  </div>
                                </ManagerIconContainer>
                                {t(company.company_name)}
                              </span>
                            </div>
                          )): null}
                      </Locationwrapper>
   
                    </React.Fragment>
                  )
                )}
                {(role === "ADMIN"||isAccountManager) && (<Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px 16px 0px',display:"flex"}}/>)}
                 
                {<StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="0px">
                  {this.props.t("Who would you like to invite?")}{<span className="imp">*</span>}
                </StyledLabel>}
                {<div className="radioButtonDiv"><RadioButtonWrapper width gap>
                  <div className="RadioButtonContainer " onClick={() => usersToInvite === 0 && this.inviteToggleButton(0)}>
                    <RadioButtonDisabled
                      type="radio"
                      name="option1"
                      disabled={usersToInvite != 0}
                      checked={usersToInvite === 0}
                      id="all-users"
                      value={0}
                      handler={this.inviteToggleButton}
                    />
                    <div className="label">All Users</div>
                  </div> 
                  {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && departmentList?.length > 0 &&<div className="RadioButtonContainer " onClick={() => usersToInvite === 1 && this.inviteToggleButton(1)}>
                    <RadioButtonDisabled
                      type="radio"
                      name="option2"
                      checked={usersToInvite === 1}
                      id="departments"
                      value={1}
                      handler={this.inviteToggleButton}
                      disabled={usersToInvite != 1}
                    />
                    <div className="label">Departments</div>
                  </div>}
                  {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && locationDetails?.length > 0 &&<div className="RadioButtonContainer " onClick={() => usersToInvite === 2 && this.inviteToggleButton(2)}>
                    <RadioButtonDisabled
                      type="radio"
                      name="option3"
                      checked={usersToInvite === 2}
                      id="locations"
                      value={2}
                      handler={this.inviteToggleButton}
                      disabled={usersToInvite != 2}
                    />
                    <div className="label">Locations</div>
                  </div>}
                  {((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && allTeams.length > 0 &&<div className="RadioButtonContainer " onClick={() => usersToInvite === 3 && this.inviteToggleButton(3)}>
                    <RadioButtonDisabled
                      type="radio"
                      name="option4"
                      checked={usersToInvite === 3}
                      id="teams"
                      value={3}
                      handler={this.inviteToggleButton}
                      disabled={usersToInvite !== 3}
                    />
                    <div className="label">Teams</div>
                  </div>}
                </RadioButtonWrapper></div>}
                {usersToInvite !==0 && <Border style={{background:'#EFEFEF',margin:'8px 0px 8px 0px'}}/>}
                {/* <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px 0px 0px',display:"flex"}}/> */}
                {((role === "ADMIN"||isAccountManager) &&
                  locationDetails &&
                  locationDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1 && usersToInvite === 2) ||
                (locationDetails &&
                  locationDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager) && usersToInvite === 2) ? (
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">
                      {this.props.t("Select Locations")}{<span className="imp">*</span>}
                    </StyledLabel>
                  ) : null}

                {((role === "ADMIN"||isAccountManager) &&
                  locationDetails &&
                  locationDetails?.length > 0 &&
                  selectedCompanyCheckBox === 1  && usersToInvite === 2) ||
                (locationDetails &&
                  locationDetails?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 2) ? (<Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}} isWidth="25%" marginTop="12px">
                    <div className="checkBoxWidth" >
                      <span style={{color: selected_city_location?.length===locationDetails?.length?"#BDBDBD": "#092F41",gap:"16px"}}>
                        <ManagerIconContainer selected={city_location?.length === locationDetails?.length} disabled={selected_city_location?.length===locationDetails?.length} isWidth="20px" isHeight="20px">
                          <div
                            className="archive-action"
                            onClick={(e) =>selected_city_location != locationDetails?.length && this.selectAllLocation(e, locationDetails)}
                          >
                            {selected_city_location?.length===locationDetails?.length?RecognitionTickIcon("#BDBDBD"):  city_location?.length === locationDetails?.length
                              ? RecognitionTickIcon()
                              : null}
                          </div>
                        </ManagerIconContainer>
                        {locationDetails &&
                        city_location?.length === locationDetails?.length
                          ? this.props.t("Deselect All")
                          : this.props.t("Select All")}
                      </span>
                    </div>
                    {locationDetails && locationDetails?.length > 0
                      ? locationDetails.map((loc, index) => (
                        <div className="checkBoxWidth" key={index}>
                          <span style={{color: selected_city_location && selected_city_location.includes(loc.id) && city_location && city_location.includes(loc.id)?"#BDBDBD": "#184A61", gap:"16px"}}>
                            <ManagerIconContainer selected={selected_city_location && selected_city_location.includes(loc.id) && city_location && city_location.includes(loc.id)?0: city_location && city_location.includes(loc.id)?1: 0} disabled={selected_city_location && selected_city_location.includes(loc.id) && city_location && city_location.includes(loc.id)} isWidth="20px" isHeight="20px" >
                              <div
                                className="archive-action"
                                onClick={selected_city_location && selected_city_location.includes(loc.id) &&city_location &&city_location.includes(loc.id)
                                  ? null: () => this.onChangeLocation(loc.id)}
                              >
                                {selected_city_location && selected_city_location.includes(loc.id) && city_location && city_location.includes(loc.id)
                                  ? RecognitionTickIcon("#BDBDBD"):
                                  city_location && city_location.includes(loc.id)?RecognitionTickIcon()
                                    : null}
                              </div>
                            </ManagerIconContainer>
                            {this.removeCommaFromFirstPlace(loc.location)}
                          </span>
                        </div>)): null}
                  </Locationwrapper>) : null}

                {/* Dpartment Listing */}

                {((role === "ADMIN"||isAccountManager) &&
                  departmentList && 
                  departmentList?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue?.length > 0 && usersToInvite === 1) ||
                (departmentList &&
                  departmentList?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 1 ) ? (
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">
                      {this.props.t("Select Departments")}{<span className="imp">*</span>}
                    </StyledLabel>
                  ) : null}
                {((role === "ADMIN"||isAccountManager) &&
                usersToInvite === 1 && departmentList &&
                departmentList?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue?.length > 0) ||
                (departmentList &&
                  departmentList?.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 1 ) ? (
                    <Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}} isWidth="25%" marginTop="12px">
                      <div className="checkBoxWidth" >
                        <span style={{color: selected_city_department?.length=== departmentList?.length?"#BDBDBD": "#184A61", gap:"16px"}}>
                          <ManagerIconContainer selected={city_department.length === departmentList?.length} disabled={selected_city_department?.length=== departmentList?.length} isWidth="20px" isHeight="20px">
                            <div
                              className="archive-action"
                              onClick={(e) =>
                                selected_city_department.length != departmentList?.length && this.selectAllDepartment(e, departmentList)
                              }
                            >
                              {selected_city_department?.length=== departmentList?.length?RecognitionTickIcon("#BDBDBD"): departmentList && city_department.length === departmentList?.length
                                ? RecognitionTickIcon()
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {departmentList &&
                            city_department.length === departmentList?.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span>
                      </div>
                      {departmentList && departmentList?.length > 0
                        ? departmentList.map((dep, index) => (
                          <div className="checkBoxWidth" key={index}>
                            <span style={{color: selected_city_department?.includes(dep?.id)&& city_department?.includes(dep?.id)?"#BDBDBD": "#184A61", gap:"16px"}} >
                              <ManagerIconContainer selected={selected_city_department?.includes(dep?.id)&& city_department?.includes(dep?.id)?0:city_department.includes(dep.id)?1:0} disabled={selected_city_department?.includes(dep?.id)&& city_department?.includes(dep?.id)} isWidth="20px" isHeight="20px">
                                <div
                                  className="archive-action"
                                  onClick={selected_city_department?.includes(dep?.id)&& city_department?.includes(dep?.id)?null:() => this.onChangeDepartment(dep.id)}
                                >
                                  {selected_city_department?.includes(dep?.id)?
                                    RecognitionTickIcon('#BDBDBD'):
                                    city_department?.includes(dep?.id)
                                      ? RecognitionTickIcon()
                                      : null}
                                </div>
                              </ManagerIconContainer>
                              {this.removeCommaFromFirstPlace(dep.department)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {/* Teams Listing */}

                {((role === "ADMIN"||isAccountManager) &&
                  allTeams && 
                  allTeams.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue?.length > 0 && usersToInvite === 3) ||
                (allTeams &&
                  allTeams.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 3 ) ? (
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">
                      {this.props.t("Select Teams")}{<span className="imp">*</span>}
                    </StyledLabel>
                  ) : null}
                {((role === "ADMIN"||isAccountManager) &&
                usersToInvite === 3 && allTeams &&
                  allTeams?.length > 0 &&
                  selectedCompanyCheckBox === 1 &&
                  selectedCompanyValue?.length > 0) ||
                (allTeams &&
                  allTeams.length > 0 &&
                  (role != "ADMIN"&&!isAccountManager)  && usersToInvite === 3 ) ? (
                    <Locationwrapper  background="white" style={{zIndex:"10",position:"relative"}}>
                      <div className="checkBoxWidth" >
                        <span style={{color: selected_teams?.length===teams?.length?"#BDBDBD": "#184A61",gap:"16px"}}>
                          <ManagerIconContainer selected={teams?.length === allTeams?.length} disabled={selected_teams?.length===teams?.length} isWidth="20px" isHeight="20px">
                            <div
                              className="archive-action"
                              onClick={(e) =>
                                selected_teams.length != allTeams.length && this.selectAllTeams(e, allTeams)
                              }
                            >
                              {selected_teams?.length===teams?.length?RecognitionTickIcon("#BDBDBD"):  allTeams && teams.length === allTeams.length
                                ? RecognitionTickIcon()
                                : null}
                            </div>
                          </ManagerIconContainer>
                          {allTeams &&
                          teams.length === allTeams.length
                            ? this.props.t("Deselect All")
                            : this.props.t("Select All")}
                        </span>
                      </div>
                      {allTeams && allTeams.length > 0
                        ? allTeams.map((team, index) => (
                          <div className="checkBoxWidth" key={index}>
                            <span style={{color: selected_teams.includes(team.id)&& teams.includes(team.id)?"#BDBDBD": "#184A61", gap:"16px"}}>
                              <ManagerIconContainer selected={selected_teams.includes(team.id)&& teams.includes(team.id)?0:teams.includes(team.id)?1:0} disabled={selected_teams.includes(team.id)&& teams.includes(team.id)} isWidth="20px" isHeight="20px">
                                <div
                                  className="archive-action"
                                  onClick={selected_teams.includes(team.id)&&  teams.includes(team.id)?null: () => this.onTeamsCheckboxChange(team.id)}
                                >
                                  {selected_teams.includes(team.id)&&  teams.includes(team.id)
                                    ? RecognitionTickIcon('#BDBDBD'):
                                    teams.includes(team.id)?RecognitionTickIcon()
                                      : null}
                                </div>
                              </ManagerIconContainer>
                              {this.removeCommaFromFirstPlace(team.name)}
                            </span>
                          </div>
                        ))
                        : null}
                    </Locationwrapper>
                  ) : null}

                {(companyInfo?.show_spouse || companyInfo?.show_dependent ||  (locationDetails?.length === 0 && usersToInvite === 2)) && companies?.length > 0 && ((role != "ADMIN"&&!isAccountManager) || selectedCompanyCheckBox === 1) && (usersToInvite!==0 && usersToInvite!==3) ? ( <Border style={{background:'#EFEFEF',margin:'0px 0px 0px 0px',display:"flex"}}/>) : null}
                {(companyInfo?.show_spouse|| companyInfo?.show_dependent) && selectedCompanyCheckBox === 1 ?<div>
               
                  {(companyInfo?.show_spouse || companyInfo?.show_dependent ||  (locationDetails?.length === 0 && usersToInvite === 2)) && companies?.length > 0 && selectedCompanyCheckBox === 1 && (usersToInvite!==0 && usersToInvite!==3) ? (
                    <StyledLabel isFont={"14px"} color={"#184A61"} margin="8px" marginb="12px">
                      {("Are you also interested in extending an invitation?")}
                    </StyledLabel>) : null}

                  {(role === "ADMIN"||isAccountManager) && selectedCompanyCheckBox === 1 && (usersToInvite!==0 && usersToInvite!==3)? (
                    <Locationwrapper background="white" isWidth="25%" marginTop="12px">
                      {companyInfo?.show_spouse ? <div className="checkBoxWidth">
                        <span style={{color:isSpouse&&spouse?"#BDBDBD":"#092F41",gap:"16px"}}>
                          <ManagerIconContainer selected={isSpouse} disabled={spouse} isWidth="20px" isHeight="20px" >
                            <div
                              className="archive-action"
                              onClick={ ()=>{
                                spouse && isSpouse?null: this.selectSpouseDependent("isSpouse")
                              }}
                            >
                              {isSpouse
                                ? RecognitionTickIcon('#BDBDBD'):
                                spouse ?
                                  RecognitionTickIcon()
                                  : null}
                            </div>
                          </ManagerIconContainer>
                          {"Spouse"}
                        </span>
                      </div>:null}
                      {companyInfo?.show_dependent ? <div className="checkBoxWidth">
                        <span style={{color:dependent && isDependent?"#BDBDBD":"#092F41",gap:"16px"}}>
                          <ManagerIconContainer selected={isDependent} disabled={dependent} isWidth="20px" isHeight="20px" >
                            <div
                              className="archive-action"
                              onClick={()=>{
                                dependent && isDependent?null: this.selectSpouseDependent("isDependent")
                              }
                              }
                            >
                              {dependent
                                ? RecognitionTickIcon('#BDBDBD'):
                                isDependent ?
                                  RecognitionTickIcon()
                                  : null}
                            </div>
                          </ManagerIconContainer>
                          {"Dependent"}
                        </span>
                      </div>:null}
                    </Locationwrapper>
                  ) : (
                    (role != "ADMIN"&&!isAccountManager) && (usersToInvite != 0&&usersToInvite != 3) && (
                      <Locationwrapper  background="white" isWidth="25%">
                        {companyInfo?.show_spouse ? <div className="checkBoxWidth">
                          <span  style={{color:isSpouse&&spouse?"#BDBDBD":"#092F41",gap:"16px"}}>
                            <ManagerIconContainer selected={isSpouse} disabled={spouse} isWidth="20px" isHeight="20px" >
                              <div
                                className="archive-action"
                                onClick={ ()=>{
                                  spouse && isSpouse?null:  this.selectSpouseDependent("isSpouse")
                                }}
                              >
                                {spouse
                                  ? RecognitionTickIcon('#BDBDBD'):
                                  isSpouse ?
                                    RecognitionTickIcon()
                                    : null}
                              </div>
                            </ManagerIconContainer>
                            {this.props.t("Spouse")}
                          </span>
                        </div> : null}
                        {companyInfo?.show_dependent ? <div className="checkBoxWidth">
                          <span  style={{color:dependent && isDependent?"#BDBDBD":"#092F41",gap:"16px"}}>
                            <ManagerIconContainer selected={isDependent} disabled={dependent} isWidth="20px" isHeight="20px" >
                              <div
                                className="archive-action"
                                onClick={()=>{
                                  dependent&&isDependent ?null: this.selectSpouseDependent("isDependent")
                                }
                                }
                              >
                                {dependent
                                  ? RecognitionTickIcon('#BDBDBD'):
                                  isDependent ?
                                    RecognitionTickIcon()
                                    : null}
                              </div>
                            </ManagerIconContainer>
                            {this.props.t("Dependent")}
                          </span>
                        </div>: null}
        
                      </Locationwrapper>
                    )
                  )}</div>:null}
               
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  setDatePickerWrapper = (node) => {
    this.datePickerWrapper = node;
  };

  changeDate = (e, stateName) => {
    const { showDateTimeInput } = this.state;
    if (showDateTimeInput === 'date') {
      this.setState({
        date: dayjs(e._d).format('MM/DD/YYYY'),
        time: dayjs(e._d).format('hh:mm a'),
        endDate: dayjs(e._d).format('MM/DD/YYYY'),
        endTime: '11:59 pm',
        openDateTimePicker: '',
      });
    } else if (stateName.includes('ate')) {
      if(stateName === 'date'){
        this.setState({
          openDateTimePicker: '',
          [stateName]: dayjs(e._d).format('MM/DD/YYYY'),
          endDate:dayjs(e._d).format('MM/DD/YYYY'),
        });
      }else {
        this.setState({
          openDateTimePicker: '',
          [stateName]: dayjs(e._d).format('MM/DD/YYYY'),
        });

      }
    } else {
      this.setState({
        [stateName]: dayjs(e._d).format('hh:mm a'),
        openDateTimePicker: stateName
      });
    }
  };

  showDatePicker = (value) => {
    if (this.state.openDateTimePicker === value) {
      this.setState({
        openDateTimePicker: ''
      });
    } else {
      this.setState({
        openDateTimePicker: value
      });
    }
  };

  onChangeEmail = (key) => {
    const { emailOption } = this.state;
    emailOption[key] = emailOption[key] === 0 ? 1 : 0;
    this.setState({ emailOption: emailOption });
  }

  checkBase64(image) {
    if (image) {
      if (image.includes('base64')) {
        return true;
      }
      else {
        return false;
      }
    }
  }

  onSubmit = () => {
    // e.preventDefault();
    const { title, date, description, editImage, endDate, activityType, challengePointValue, challengeMode, weeklyIncrement,
      survivorAverage, companies, isSpouse, isDependent, isEmployee, survivorChallenge, groupChallenge, /*imageUpdated,*/ emailOption, locationPermission, surveyId, selectedOption, dailyGoal, selectedDailyGoalOption, imageName, apiChecker, usersToInvite, selectedCompanyCheckBox, city_department,survivorEndDateValue, lastDayToJoin, challengeLength } = this.state;
    const { companyDetails, createLibrary, activityChallengeById, editLibrary, /*createActivityChallenge,*/ saveChallengeData, /*editLiveChallenge,*/ role, isAccountManager } = this.props;
    // let survivorEndDate = moment(moment(date).add((challengeLength * 7) - 1, 'days')._d).format('MM/DD/YYYY');
    let survivorEndDate = dayjs(dayjs(date).add((challengeLength * 7) - 1, 'days')).format('MM/DD/YYYY');
    const challengeType = survivorChallenge ? 'survivor' : groupChallenge ? 'new_group' : 'group';
    let lastDaySelectValue= survivorChallenge?this.calculateDateDifference(date,survivorEndDateValue): (date&&endDate) && this.calculateDateDifference(date,endDate)
    this.setState({ buttonStatus: true });
    const challenge = {
      title,
      companies: companies,
      body: description,
      image: editImage,
      event_type: groupChallenge ? activityType === 'Total Group Steps' ? 'Total Steps' : activityType === 'Total Group Calories' ? 'Total Calories' : 'Total Distance' : activityType,
      end_date: createLibrary || editLibrary ? null : (survivorChallenge) ? dayjs(survivorEndDate ).format('YYYY-MM-DD') + ' ' + "23:59:59" : dayjs(endDate).format('YYYY-MM-DD') + ' ' + "23:59:59",
      start_date: createLibrary || editLibrary ? null :   dayjs(date).format('YYYY-MM-DD') + ' ' + "00:00:00",
      survivor_average: survivorAverage,
      weekly_increment: survivorChallenge ? weeklyIncrement : null,
      challenge_point: challengePointValue,
      challenge_mode: survivorChallenge ? challengeMode : '',
      challenge_type: challengeType,
      isSurvivorChallenge: survivorChallenge,
      isGroupChallenge: groupChallenge,
      ...emailOption,
      survey_id: selectedOption === 1 ? null : surveyId,
      daily_goal: selectedDailyGoalOption === 1 ? null : dailyGoal, 
      teams:this.state.teams,
      id: this.props.survivorChallengeData['id'],
      is_team_challenge:this.state.teams.length>0?1:0,
      is_challenge_started_or_over:apiChecker,
      company_departments: city_department,
      time_zone: TimeZone,
      challenge_for_spouse : isSpouse ? 1 : 0,
      challenge_for_dependent : isDependent ? 1 : 0,
      days_until_last_date: lastDaySelectValue>3? lastDayToJoin:null
      // location: this.state.city_location
    };
    challenge.company_city_states = this.state.city_location;
    // activityChallengeById ? challenge.convert_image = !this.checkBase64(editImage) : null;
    if(activityChallengeById){
      challenge.convert_image = !this.checkBase64(editImage)
    }
    challenge.id = this.props.survivorChallengeData['id'];
    challenge.imageUpdated = this.checkBase64(editImage) ? 1 : 0;
    if (locationPermission) {
      challenge.company_city_states = this.state.city_location;
      challenge.challenge_for_spouse = isSpouse ? 1 : 0;
      challenge.challenge_for_dependent = isDependent ? 1 : 0
      if (this.props.locationDetails && this.props.locationDetails.length > 0) {
        if(this.state.city_location.length > 0){
          challenge.is_for_employee = 1
        }
        else{
          challenge.is_for_employee = 0
        }
      }
      else {
        if (companyDetails['spouse_or_dependent']) {
          challenge.is_for_employee = isEmployee ? 1 : 0
        }
        else {
          challenge.is_for_employee = 1
        }
      }
    }
    if((usersToInvite===0&&(role=="ADMIN"||isAccountManager)&&selectedCompanyCheckBox===1)||(usersToInvite===0&&(role!="ADMIN"&&!isAccountManager))){
      challenge.is_for_employee = 1;
      challenge.challenge_for_spouse =1;
      challenge.challenge_for_dependent = 1;
    }

    if(city_department?.length > 0 && usersToInvite===1){
      challenge.is_for_employee = 1;
    }
    if(usersToInvite === 0){
      challenge.company_departments = null;
      challenge.company_city_states = null;
      challenge.teams = null;
      challenge.is_for_employee = 1;
    }else if(usersToInvite === 1){
      challenge.company_departments = city_department;
      challenge.company_city_states = null;
      challenge.teams = null;
      challenge.is_for_employee = 1;
    }else if(usersToInvite === 2){
      challenge.company_departments = null;
      challenge.company_city_states = this.state.city_location;
      challenge.teams = null;
      challenge.is_for_employee = 1;
    }else if(usersToInvite === 3){
      challenge.teams = this.state.teams;
      challenge.is_team_event=1;
      challenge.company_departments = null;
      challenge.company_city_states = null;
      challenge.is_for_employee = 1;
    }
  
  
    saveChallengeData({ ...challenge, imageName });
    // editLiveChallenge(challenge);
    this.editLiveChallengeData(challenge);
  };

  editLiveChallengeData = async(payload)=>{

    this.setState({ buttonStatus: true });

    const{history} = this.props;
    try{
      const res = await fetchApi(EditChallengeAPI, "PUT",payload);

      if(res.status === "failed"){
        toast.error(res.data.message);
        this.setState({ buttonStatus: false });
      }else{
        toast.success(res.data[0]);
        if(history.location.pathname.includes("/company")){
          history.push(`/company/challenges/${payload.id}`)
        }
        else{
          history.push(`/challenges/${payload.id}`)
        }
        this.setState({ buttonStatus: false });
      }

    }catch(error){
      toast.error(error);
      this.setState({ buttonStatus: false });

    }
  }

  launchDateHideCalendar = () =>{
    this.setState({
      launchStartDateActive: false
    })
  }

  onChanegeLaunchButton = (value) => {
    this.setState({
      launchStartDate:(value),
      date: dayjs(value),
    })
  }

  onSelectWeeks = (value) => {
    this.setState({
      challengeLength: value  })
  };

  calculateDateDifference = ( date, endDate ) => {
    const start = new Date(date);
    const end = new Date(endDate);
  
    // Check if both dates are valid
    if (isNaN(start) || isNaN(end)) {
      throw new Error("Invalid date format");
    }
  
    // Reset time to midnight for accurate day diff
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
  
    const diffInMs = end - start;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
  
    return diffInDays;
  }

  lastDayRadioButton = (name, value ) => {
    this.setState({
      [name]: value,
    });
    if(name==="lastDayToJoin"){
      this.setState({
        lastDayCustom: null,
      });
    }
    if(name==="lastDayCustom"){
      this.setState({
        lastDayToJoin: null,
      });
    }
  }

  hideCalendarPopup= () =>{
    this.setState({
      showDatePopupModal: false,
      datePopup: ""
    })
  }

  onChangeDateValue = (date, stateName) => {
    this.setState({
      [stateName]: dayjs(date),
      showDatePopupModal: false
    },() => this.setEndDateSurvivor(date));
    if(this.state.datePopup==="date"){
      this.setState({
        launchStartDate: dayjs(date)
      })
    }
  };

  resetDatePopup = () =>{
    if(this.state.datePopup==="date"){
      this.setState({
        date: null,
        launchStartDate: null
      })
    }else{
      this.setState({
        endDate: null, 
        launchEndDate:null
      })
    }
  }

  hideShowCalendarPopup = (value) =>{
    this.setState({
      datePopup: value,
      showDatePopupModal: true
    })
  }

  stepFourForm = () => {
    const {
      step,
      date,
      endDate,
      launchEndDate,
      launchStartDate,
      challengeLength,
      lastDayToJoin,
      lastDayCustom,
      survivorChallenge,
      showDatePopupModal,
      datePopup
    } = this.state;
    const {t, survivorChallengeData} = this.props;
    let currentDate = dayjs();
    const survivorChallengeLengthDropdown = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const startChallengeEditButton= dayjs(convertDateInTimezone(survivorChallengeData.start_date)._d).format('MM-DD-YYYY')<=dayjs(currentDate).format('MM-DD-YYYY')&&survivorChallengeData.is_user_challenge!==1&&survivorChallengeData.challenge_status!="over"&&!survivorChallengeData.is_global_challenge?true:false;
    let survivorEndDate = dayjs(dayjs(date).add((challengeLength * 7) - 1, 'days')).format('MM/DD/YYYY');
    let lastDaySelectValue= survivorChallenge?(date&&survivorEndDate)&& this.calculateDateDifference(date,survivorEndDate): (date&&endDate) && this.calculateDateDifference(date,endDate)
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87">
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challenge" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px">
                  {t("When would you like to launch your challenge?")}{<span className="imp">*</span>}
                </StyledLabel>
                {
                  <div className="dateCard" style={{marginTop:"16px",gap:"8px"}}>  
                    <DateCalendarWrapper>
                      <div className="date-title">Start Date</div>
                      <DateCard color={startChallengeEditButton} background={startChallengeEditButton} disabled={startChallengeEditButton} onClick={startChallengeEditButton?null: ()=>this.hideShowCalendarPopup("date")}>
                        {launchStartDate? dayjs(launchStartDate).format('MM/DD/YYYY'): "Select Date"}
                        {CalendarBranding(startChallengeEditButton? "#BDBDBD":"#F37A65")}
                      </DateCard>
                    </DateCalendarWrapper> 
                    {survivorChallengeData.challenge_type=="survivor"?
                      <TitleContainer height="auto" padding="0">
                        <p className="date-title" style={{marginBottom:"12px"}}>Weeks to end</p>
                        <CommonDropdown
                          tileContainerStyle={{ width: "100%", padding: "0px 0px 0px 0px" }}
                          dropdownStyle={{ top: "90px" }}
                          isRequired={true}
                          dropdownOpen={this.state.weekArrow}
                          placeholder={t("Select weeks to end")}
                          title={challengeLength && `${challengeLength} ${t("Weeks")}`}
                          id="dropdown-recurring"
                          onClick={() => this.setState({ weekArrow: !this.state.weekArrow })}
                          data={survivorChallengeLengthDropdown}
                          onSelect={this.onSelectWeeks}
                          active={challengeLength}
                          onSelectParameter={["value"]}
                          itemValue={false}
                          t={t}
                          isManagerMargin={"0px"}
                          labelMargin={"0px"}
                          fontSize={"14px"}
                          valueIndex={1}
                          dropIcon={true}
                          top={"7px"}
                          height={"50px"}
                          valueString={"Weeks"}
                        />
                      </TitleContainer>:
                      <DateCalendarWrapper>
                        <div className="date-title">End Date</div>
                        <DateCard onClick={()=>this.hideShowCalendarPopup("endDate")}>
                          {endDate || launchEndDate?  dayjs(endDate || launchEndDate).format('MM/DD/YYYY'):"Select Date"}
                          {CalendarBranding()}
                        </DateCard>
                      </DateCalendarWrapper>}
                  </div>}

                {lastDaySelectValue>3?<>
                  {<Border style={{ background: '#EFEFEF', margin: '8px 0 8px 0px' }} />}
                  <StyledLabel isFont={"14px"} color={"#184A61"} marginb="0px" margin="0px">
                    {this.props.t("Last day to join after the challenge is launched")}<span className="imp">*</span>
                  </StyledLabel>
                  <div className="radioButtonDiv">
                    <RadioButtonWrapper width gap>
                      {<div className="RadioButtonContainer " onClick={() => this.lastDayRadioButton("lastDayToJoin",3)}>
                        <RadioButton
                          id="lastDayCustom3"
                          handler={this.lastDayRadioButton}
                          value={3}
                          checked={lastDayToJoin === 3}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="option1"
                        />
                        <div className="label">{this.props.t("3 days")}</div>
                      </div>}
                      {lastDaySelectValue>7?<div className="RadioButtonContainer " onClick={lastDayToJoin===7?null: () => this.lastDayRadioButton("lastDayToJoin",7)}>
                        <RadioButton
                          id="lastDayCustom7"
                          handler={this.lastDayRadioButton}
                          value={7}
                          checked={lastDayToJoin === 7}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="option2"
                        />
                        <div className="label">{this.props.t("7 days")}</div>
                      </div>:null}
                      {lastDaySelectValue>14?<div className="RadioButtonContainer " onClick={lastDayToJoin===14?null: () => this.lastDayRadioButton("lastDayToJoin",14)}>
                        <RadioButton
                          id="lastDayCustom14"
                          handler={this.lastDayRadioButton}
                          value={14}
                          checked={lastDayToJoin === 14}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="option3"
                        />
                        <div className="label">{this.props.t("14 days")}</div>
                      </div>:null}
                      <div className="RadioButtonContainer " onClick={lastDayCustom==="Custom"?null: () => this.lastDayRadioButton("lastDayCustom","Custom")}>
                        <RadioButton
                          id="custom"
                          handler={ lastDayCustom==="Custom"?null:this.lastDayRadioButton}
                          value={"Custom"}
                          checked={lastDayCustom=== "Custom"}
                          style={{color:"#092F41"}}
                          type="radio"
                          name="option4"
                        />
                        <div className="label">{this.props.t("Custom")}</div>
                      </div>
                    </RadioButtonWrapper>
                  </div>

                  {lastDayCustom==="Custom"?
                    <>
                      <Border style={{ background: '#EFEFEF', margin: '8px 0 8px 0px' }} />
                      <SurvivorAverage width="100%" isHeight={"50px"} isMargin="0px" marginb="0px">
                        <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px">
                          {t("Custom last day to join")}
                        </StyledLabel>
                        <CustomInput
                          isFont={"Lato"}
                          isRadius={"4px"}
                          isBorder={"1px solid #BDBDBD"}
                          isBgColor={"white"}
                          type='number'
                          name='lastDayToJoin'
                          onChange={this.onChangeInput}
                          value={lastDayToJoin}
                          maxLength="3"
                          placeholder={"Enter number of days"}
                        />
                      </SurvivorAverage>
                    </>:null}
                </>:null}
                {showDatePopupModal&&<DatePopupCalendar showModal={showDatePopupModal} onClose={this.hideCalendarPopup} date={datePopup==="date"? date: endDate} stateDateSelected={ datePopup==="date"?dayjs(new Date()):date} changeDate={this.onChangeDateValue} type={datePopup} resetDatePopup={this.resetDatePopup}/>}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepFiveForm = () => {
    const {
      step,
      emailOption,
    } = this.state;
    const {t} = this.props;
    let emailOptionKeys = Object.keys(emailOption);
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>
            <div className="stepsNameHighlight">
              <StepsHeading stepCount={step} type="challenge" padding="20px 20px 265px 20px"/>
            </div>
            <div className="form">
              <div className="formBody">
                {<StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="0">
                  {t("Email notifications: Select email option for this challenge")}
                </StyledLabel>}
                <div className="radioButtonDiv">
                  <Locationwrapper background="white" isFlex={'1 1 50%'} style={{flexWrap:"nowrap"}} isWidth="25%" marginTop="12px">
                    {emailOptionKeys.map((item, index) => (
                      <div className="checkBoxWidth" key={index}>
                        <span style={{color:"#092F41",gap:"16px"}}>
                          <ManagerIconContainer selected={emailOption[item] === 1} isWidth="20px" isHeight="20px">
                            <div
                              className="archive-action"
                              onClick={() => this.onChangeEmail(item)}
                            >
                              {emailOption[item] === 1 ? RecognitionTickIcon(): null}
                            </div>
                          </ManagerIconContainer>
                          {t("Challenge")}
                          {item == "launch_challenge_email"? t(" Creation"): item == "challenge_reminder_email"? t(" Reminder"): t(" Completion")}
                        </span>
                      </div>))}           
                  </Locationwrapper>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  DropdownIndicator = () => (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10C12 10.3585 11.8559 10.7169 11.5684 10.9901L2.51663 19.5897C1.94083 20.1368 1.00725 20.1368 0.431681 19.5897C-0.143894 19.0429 -0.143894 18.1561 0.431681 17.609L8.44122 10L0.43196 2.39098C-0.143614 1.84394 -0.143614 0.957264 0.43196 0.410484C1.00753 -0.136826 1.94111 -0.136826 2.51691 0.410484L11.5687 9.00992C11.8563 9.28333 12 9.64172 12 10Z"
        fill="#0D4270"
      />
    </svg>
  );

  toggleMenu = () => {
    this.setState((prevState) => ({
      menuIsOpen: !prevState.menuIsOpen,
    }));
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true, buttonStatus:false });
  };

  render() {
    const { step, buttonStatus, title, imgSrc, description, activityType,  usersToInvite, city_location, teams, allTeams, date, endDate, selectedCompanyCheckBox, companies, isEmployee,isDependent,isSpouse, challengeLength, survivorChallenge, lastDayToJoin} = this.state;
    const {locationDetails, allCompanies, role, isAccountManager} = this.props;
    let survivorEndDate = dayjs(dayjs(date).add((challengeLength * 7) - 1, 'days')).format('MM/DD/YYYY');
    let lastDaySelectValue = survivorChallenge?this.calculateDateDifference(date,survivorEndDate): (date&&endDate) && this.calculateDateDifference(date,endDate)
    return (
      <React.Fragment>
        {step === 1?this.stepOneForm(): step === 2? this.stepTwoForm(): step === 3 ? this.stepThreeForm(): step === 4? this.stepFourForm() : step===5&& this.stepFiveForm()}
        {step === 1 ? (
          <ButtonContainer>
            <Main>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!title||!imgSrc|| !description} onClick={!title||!imgSrc|| !description?null: () => this.updateStep(2)}>
                Next
                {!title||!imgSrc|| !description ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              </CommonButtonPopup>
            </Main>
          </ButtonContainer>
        ) : step === 2 ? (
          <ButtonContainer>
            <div className="wrapper">
              <CommonButtonBorder width="200px" height="48px"
                onClick={() => this.updateStep(1)}
                margin="auto auto auto 0px">
                {AdminLeftArrowIcon("#F37A65")}
                Back
              </CommonButtonBorder>
              <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!activityType} onClick={!activityType?null: () => this.updateStep(3)}>
                Next
                {!activityType ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
              </CommonButtonPopup>
            </div>
          </ButtonContainer>
        ) : (
          step === 3 ? (
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(2)}
                  margin="auto auto auto 0px">
                  {AdminLeftArrowIcon("#F37A65")}
                  Back
                </CommonButtonBorder>
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={((role!="ADMIN"&&!isAccountManager)&&((usersToInvite===2&&((!city_location.length && locationDetails) &&((!isSpouse && !isDependent && !isEmployee))))||(((allTeams&&!teams.length)&&(!isSpouse && !isDependent && !isEmployee))&&usersToInvite===3)))||(role=="ADMIN"||isAccountManager)&&(selectedCompanyCheckBox===0&&companies.length<2&&allCompanies)||(selectedCompanyCheckBox===1&&((usersToInvite===2&&((!city_location.length && locationDetails)&&(!isSpouse && !isDependent && !isEmployee) ))||(((allTeams&&!teams.length) &&((!isSpouse && !isDependent && !isEmployee)))&&usersToInvite===3)))} onClick={((role!="ADMIN"&&!isAccountManager)&&((usersToInvite===2&&((!city_location.length && locationDetails) &&((!isSpouse && !isDependent && !isEmployee))))||(((allTeams&&!teams.length)&&(!isSpouse && !isDependent && !isEmployee))&&usersToInvite===3)))||(role=="ADMIN"||isAccountManager)&&(selectedCompanyCheckBox===0&&companies.length<2&&allCompanies)||(selectedCompanyCheckBox===1&&((usersToInvite===2&&((!city_location.length && locationDetails)&&(!isSpouse && !isDependent && !isEmployee) ))||(((allTeams&&!teams.length) &&((!isSpouse && !isDependent && !isEmployee)))&&usersToInvite===3)))?null: () => this.updateStep(4)}>
                  Next
                  {((role!="ADMIN"&&!isAccountManager)&&((usersToInvite===2&&((!city_location.length && locationDetails) &&((!isSpouse && !isDependent && !isEmployee))))||(((allTeams&&!teams.length)&&(!isSpouse && !isDependent && !isEmployee))&&usersToInvite===3)))||(role=="ADMIN"||isAccountManager)&&(selectedCompanyCheckBox===0&&companies.length<2&&allCompanies)||(selectedCompanyCheckBox===1&&((usersToInvite===2&&((!city_location.length && locationDetails)&&(!isSpouse && !isDependent && !isEmployee) ))||(((allTeams&&!teams.length) &&((!isSpouse && !isDependent && !isEmployee)))&&usersToInvite===3))) ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>
          ):step === 4 ?
            <ButtonContainer>
              <div className="wrapper">
                <CommonButtonBorder width="200px" height="48px"
                  onClick={() => this.updateStep(3)}
                  margin="auto auto auto 0px">
                  {AdminLeftArrowIcon("#F37A65")}
                  Back
                </CommonButtonBorder>
                <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!date&&!endDate|| (lastDaySelectValue>3&& !lastDayToJoin)|| buttonStatus} onClick={!date&&!endDate|| (lastDaySelectValue>3&& !lastDayToJoin)|| buttonStatus?null: () => this.updateStep(5)}>
                  Next
                  {!date&&!endDate|| (lastDaySelectValue>3&& !lastDayToJoin) ||buttonStatus? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
                </CommonButtonPopup>
              </div>
            </ButtonContainer>:
            step === 5&&
              <ButtonContainer>
                <div className="wrapper">
                  <CommonButtonBorder width="200px" height="48px"
                    onClick={() => this.updateStep(4)}
                    margin="auto auto auto 0px">
                    {AdminLeftArrowIcon("#F37A65")}
                    Back
                  </CommonButtonBorder>
                  <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={buttonStatus} onClick={!buttonStatus? () => this.onSubmit():null}>
                    Save Changes
                    {RecognitionTickIcon(buttonStatus?'#989898':"#F8F8F8")}
                  </CommonButtonPopup>
                </div>
              </ButtonContainer>
        )}
      </React.Fragment>
    );
  }
}

EditChallenge.propTypes = {
  isSurvivorChallenge: PropTypes.bool.isRequired,
  createChallenge: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  onHide: PropTypes.func,
  MandatoryFields: PropTypes.array.isRequired,
  survivorChallengeData: PropTypes.object,
  saveChallengeData: PropTypes.func.isRequired,
  allCompanies: PropTypes.array,
  fetchAllCompanies: PropTypes.func.isRequired,
  role: PropTypes.string,
  fetchCompanyForUser: PropTypes.func.isRequired,
  userCompany: PropTypes.object,
  locationDetails: PropTypes.array,
  companyDetails: PropTypes.object,
  allowChallengeEventForSpouseDependent: PropTypes.func,
  isGroupChallenge: PropTypes.bool,
  activityChallengeById: PropTypes.bool,
  createActivityChallenge: PropTypes.func,
  createLibrary: PropTypes.bool,
  editChallengeLibrary: PropTypes.func,
  editLibrary: PropTypes.bool,
  userPermissions: PropTypes.array,
  surveyLibraries: PropTypes.array,
  getSurveyLibraries: PropTypes.func,
  t: PropTypes.func,
  fetchCompanyTeamUsers:PropTypes.func,
  challengeDetails: PropTypes.array,
  getChallengeDetails: PropTypes.func,
  getCompanyLocation: PropTypes.func,
  user: PropTypes.object,
  editLiveChallenge: PropTypes.func,
  departmentList: PropTypes.array,
  getCompanyDepartment: PropTypes.func,
  isAccountManager: PropTypes.bool
};

const mapStateToProps = (state) => ({
  allCompanies: state.challenges.allCompanies,
  userCompany: state.profileData.userCompany,
  locationDetails: state.register.locationDetails,
  companyDetails: state.profileData.companyDetails,
  userPermissions: state.profileData.userPermissions,
  surveyLibraries: state.surveys.surveyLibraries,
  challengeDetails: state.challenges.challengeDetails,
  user: state.profileData.user,
  departmentList: state.register.departmentDetails,
});

const mapDispatchToProps = (dispatch) => ({
  saveChallengeData: (data) => dispatch(saveChallengeData(data)),
  fetchCompanyForUser: () => dispatch(getUserCompanyDetails()),
  allowChallengeEventForSpouseDependent: () => dispatch(allowChallengeEventForSpouseDependent),
  editChallengeLibrary: (challenge) => dispatch(editChallengeLibrary(challenge)),
  fetchCompanyTeamUsers: (companyId) => dispatch(fetchCompanyTeamUsers(companyId)),
  createActivityChallenge: (challenge) => dispatch(createActivityChallengeV2(challenge)),
  getChallengeDetails: (id) => dispatch(getChallengeDetails(id)),
  getCompanyLocation: (id) => dispatch(getCompanyLocation(id)),
  editLiveChallenge: (data, path) => dispatch(editLiveChallenge(data, path)),
  getCompanyDepartment: (id) => dispatch(getCompanyDepartment(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EditChallenge));
